import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const AgentCatalogPage = lazy(() => import('./AgentCatalogPage'));
const OrgAgentsPage = lazy(() => import('./OrgAgentsPage'));

export const agentRoutes: RouteObject[] = [
  {
    path: 'agents/catalog',
    element: (
      <ProtectedRoute action="agents:view">
        <AgentCatalogPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'agents/org',
    element: (
      <ProtectedRoute action="agents:view">
        <OrgAgentsPage />
      </ProtectedRoute>
    ),
  },
];
